module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADkAAAA5BAMAAAB+Np62AAAAGFBMVEUAAABCQkL///9CQkJCQkJCQkJCQkJCQkLjEth9AAAAB3RSTlMAAAAOjdHmjRymqwAAAEtJREFUOMtjYKAZEHYrxwHKnBUYTMtxglIDBnfcsuUODOl4ZBMY8EiWFxDQi99e/G7G719BHEAJCEZlqSc7mupGU91oqhvYVEczAAAP+5SYja0uGwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./ngapp/images/icon_menu_collapse.png
// module id = 9
// module chunks = 0